import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'comp-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent {
  done = input.required<number>();
  total = input.required<number>();
  isRow = input<boolean>(false);
  showLabel = input<boolean>(true);

  protected percentage = computed(() => {
    const total = this.total();

    if (total <= 0) {
      return 0;
    }

    const percentage = (this.done() / total) * 100;

    return Math.max(0, Math.min(100, percentage));
  });
}
